export const networkReportSectionPath = (networkId, section) =>
  `/app/network/${networkId}/report/${section}`;

export const networkReportOrganizationsPath = (networkId) =>
  networkReportSectionPath(networkId, "organizations");

export const networkReportPairingPath = (networkId) =>
  networkReportSectionPath(networkId, "pairing");

export const networkReportSchoolsFactorsPath = (networkId) =>
  networkReportSectionPath(networkId, "schools-factors");

export const networkOrganizationReportPath = (networkId, organizationSurveyId) =>
  `/app/network/${networkId}/results/${organizationSurveyId}/report`;

export const networkOrganizationWorkbookPath = (networkId, organizationId) =>
  `/app/network/${networkId}/organizations/${organizationId}/workbook`;
